import React from 'react';

import { DishType } from '../types';

type Props = {
  dish: DishType;
  containerStyle?: React.CSSProperties;
};

export const Name: React.FC<Props> = ({dish, containerStyle}) => {
  const maxLength = 30;
  return (
    <h5
      className="number-of-lines-2"
      style={{
        fontFamily: 'DM Sans, sans-serif',
        fontSize: 15,
        fontWeight: 600,
        color: 'var(--main-color)',
        lineHeight: 1.4,
        margin: 0,
        ...containerStyle,
      }}
    >
      {dish.name.length > maxLength
        ? dish.name.slice(0, maxLength - 3) + "..."
        : dish.name}
    </h5>
  );
};
